import Users from "views/Admin/Users.jsx";
import Locations from "views/Admin/Locations.jsx";
import Shipments from "views/Admin/Shipments.jsx";
import Calendar from "views/Admin/Calendar.jsx";
import Transfers from "views/Admin/Transfers.jsx";


const adminRoutes = [
    {
    path: "/admin/locations",
    name: "Locations",
    short: "Lock",
    mini: "L",
    dontShowInHeader: true,
    component: Locations,
  },
  {
    path: "/admin/users",
    name: "Users",
    short: "Lock",
    mini: "U",
    dontShowInHeader: true,
    component: Users,
  },
      {
    path: "/admin/shipments",
    name: "Shipments",
    short: "Lock",
    mini: "S",
    dontShowInHeader: true,
    component: Shipments,
  },      {
    path: "/admin/calendar",
    name: "Calendar",
    short: "Lock",
    mini: "CA",
    dontShowInHeader: true,
    component: Calendar,
  },      {
    path: "/admin/transfers",
    name: "Transfers",
    short: "Lock",
    mini: "T",
    dontShowInHeader: true,
    component: Transfers,
  }, 

];


export default adminRoutes;



// WEBPACK FOOTER //
// ./src/routes/admin.jsx